var _Skeleton, _Skeleton2, _Skeleton3, _Skeleton4, _Skeleton5, _Skeleton6, _Divider, _Skeleton7, _Skeleton8;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, Button, Container, Divider, IconArrowBack, IconButton, Paper, Skeleton, Stack, Typography } from '@lumahealthhq/ui-core';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerCopayDetermination() {
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Container, {
    maxWidth: false,
    disableGutters: true,
    children: [/*#__PURE__*/_jsxs(Stack, {
      alignItems: "center",
      justifyContent: "space-between",
      direction: "row",
      mb: 3,
      children: [/*#__PURE__*/_jsxs(Stack, {
        alignItems: "center",
        direction: "row",
        gap: 2,
        children: [/*#__PURE__*/_jsx(IconButton, {
          "aria-label": intl.formatMessage({
            id: "orvpWh",
            defaultMessage: [{
              "type": 0,
              "value": "Go back"
            }]
          }),
          children: /*#__PURE__*/_jsx(IconArrowBack, {
            sx: function sx(theme) {
              return {
                color: theme.palette.common.black
              };
            }
          })
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          textTransform: "capitalize",
          children: intl.formatMessage({
            id: "xtf2vj",
            defaultMessage: [{
              "type": 0,
              "value": "View eligibility details"
            }]
          })
        })]
      }), _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
        height: 18,
        width: 264
      }))]
    }), /*#__PURE__*/_jsxs(Box // GridTemplate
    , {
      sx: {
        display: 'grid',
        gap: 5,
        gridTemplateColumns: 'repeat(3, 1fr) 320px',
        gridTemplateAreas: "\n          'insurance insurance insurance info'\n          'insurance insurance insurance .'\n        "
      },
      children: [/*#__PURE__*/_jsxs(Stack // MainContainer
      , {
        component: Paper,
        gap: 5,
        overflow: "auto",
        flexGrow: 1,
        px: 5,
        py: 4,
        gridArea: "insurance",
        children: [_Skeleton2 || (_Skeleton2 = /*#__PURE__*/_jsx(Skeleton, {
          height: 65,
          width: "100%"
        })), " ", /*#__PURE__*/_jsxs(Stack, {
          gap: 2,
          children: [_Skeleton3 || (_Skeleton3 = /*#__PURE__*/_jsx(Skeleton, {
            width: "100%",
            height: 300
          })), " ", _Skeleton4 || (_Skeleton4 = /*#__PURE__*/_jsx(Skeleton, {
            width: "100%",
            height: 72
          })), " ", _Skeleton5 || (_Skeleton5 = /*#__PURE__*/_jsx(Skeleton, {
            width: "100%",
            height: 72
          })), " "]
        })]
      }), /*#__PURE__*/_jsxs(Stack // SideContainer
      , {
        component: Paper,
        gap: 3,
        p: function p(theme) {
          return "".concat(theme.spacing(4), " ").concat(theme.spacing(2), " ").concat(theme.spacing(2));
        },
        maxWidth: 320,
        minWidth: 320,
        gridArea: "info",
        children: [_Skeleton6 || (_Skeleton6 = /*#__PURE__*/_jsx(Skeleton, {
          width: "100%",
          height: 80
        })), " ", _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            sx: {
              mb: 1
            },
            children: intl.formatMessage({
              id: "82aMWa",
              defaultMessage: [{
                "type": 0,
                "value": "Appointment"
              }]
            })
          }), _Skeleton7 || (_Skeleton7 = /*#__PURE__*/_jsx(Skeleton, {
            width: "100%",
            height: 138
          }))]
        }), /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            sx: {
              mb: 2
            },
            children: intl.formatMessage({
              id: "Fn5tXl",
              defaultMessage: [{
                "type": 0,
                "value": "Determine copay amount to charge patient for this appointment:"
              }]
            })
          }), /*#__PURE__*/_jsxs(Stack, {
            alignItems: "flex-end",
            children: [_Skeleton8 || (_Skeleton8 = /*#__PURE__*/_jsx(Skeleton, {
              width: "100%",
              height: 60
            })), /*#__PURE__*/_jsx(Button, {
              disabled: true,
              variant: "primary",
              type: "submit",
              sx: {
                mt: 3,
                width: 'fit-content'
              },
              children: intl.formatMessage({
                id: "2nBHpt",
                defaultMessage: [{
                  "type": 0,
                  "value": "Determine amount"
                }]
              })
            })]
          })]
        })]
      })]
    })]
  });
}